import CommonIcon from '_c/common-icon'
export default {
  components: {
    CommonIcon
  },
  methods: {
    showTitle (item) {
      return item[this.$config.router.labelKey] || ''
    },
    showChildren (item) {
      // TODO 只有一个功能是否需要挂出父菜单
      return item[this.$config.router.childrenKey] && item[this.$config.router.childrenKey].length > 0
    },
    getNameOrHref (item, children0) {
      return item[this.$config.router.blank] ? `isTurnByHref_${item[this.$config.router.urlKey]}` : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/view/main/components/side-menu/mixin.js